import "./App.css"
import React, { useEffect } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { ROUTES } from "./common/constant";
import Patient from "./pages/[Patient]";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login/Login";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import Guidelines from "./pages/Guidelines";
import SharedConversation from "./pages/SharedConversation";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { LanguageProvider, useLanguage } from "./contexts/LanguageContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { AppThemeProvider } from "./contexts/ThemeContext";
import { ChatStreamProvider } from "./contexts/ChatStreamContext";
import { SnackbarHost } from "./common/services/snackbar";

/** Syncs the app's active language with the logged-in user's persisted preference (users.language). */
const LanguageSyncBridge: React.FC = () => {
  const { user } = useAuth();
  const { setAllowedLanguages } = useLanguage();
  useEffect(() => {
    if (user?.language) {
      setAllowedLanguages([user.language]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.language]);
  return null;
};

function App() {
  return (
    <AppThemeProvider>
    <Router>
      <LanguageProvider>
        <AuthProvider>
          <LanguageSyncBridge />
          <ChatStreamProvider>
          <SnackbarHost />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path={ROUTES.DASHBOARD}
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES._PATIENT_BY_ID}
              element={
                <ProtectedRoute>
                  <Patient />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES._CONVERSATION}
              element={
                <ProtectedRoute>
                  <Patient />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES._SHARED_BY_ID}
              element={
                <ProtectedRoute>
                  <SharedConversation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/guidelines"
              element={
                <ProtectedRoute>
                  <Guidelines />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
          </Routes>
          </ChatStreamProvider>
        </AuthProvider>
      </LanguageProvider>
    </Router>
    </AppThemeProvider>
  );
}

export default App;
